<template>
  <b-modal 
    id="historico-status-tecnico"
    centered
    size="lg"
    :visible="false"
    :no-close-on-backdrop="true"
    :hide-footer="true"
    @shown="getHistorico"
  >
    <div class="col-12 px-0">
      <div class="col-12">
          <h4><i class="fas fa-history">  </i>  Histórico de Status</h4>
      </div>
      <load v-if="loading" mode="table" />
      <div v-else class="col-md-12 mb-3">
        <div v-if="!historicos.length">Nenhum registro encontrado</div>
        <table
          class="table table-bordered bg-white table-sm"
          v-for="historico in historicos"
          :key="historico.id"
        >
          <tr>
            <td class="bg-gray" colspan="2">
              O Status deste <b>Técnico</b> foi atualizado de
              <b>{{ getStatusTitulo(historico.status_anterior) }}</b> para
              <b>{{ getStatusTitulo(historico.status_atual) }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Técnico: <b>{{ historico.user_id }}</b>
            </td>
            <td>Data manual da ação: {{ historico.data_atualizacao }}</td>
          </tr>
          <tr>
            <td colspan="2" v-if="historico.motivo">
              Motivo: <b>{{ historico.motivo.descricao }}</b>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <p><b>Descrição do Motivo</b></p>
              {{ historico.observacoes }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["id", "status"],
  data() {
    return {
      loading: true,
      tecnico: this.nome,
      historicos: {},
    };
  },
  methods: {
    getStatusTitulo(status_id) {
      if (this.status.length != undefined) {
        const result = this.status.filter((item) => item.id == status_id);
        return result[0] ? result[0].value : "";
      }
    },

    getHistorico() {
      console.log(this.tecnico);
      this.loading = true;
      axios
        .get("api/dashboard/tecnicos/historico/status/" + this.id)
        .then((response) => {
          this.historicos = response.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          swal.fire({
            title: "Ops!",
            html:
              "Histórico do Status não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
  },
};
</script>
